import { render, staticRenderFns } from "./DialogForgotPasword.vue?vue&type=template&id=529e49bc&scoped=true&"
import script from "./DialogForgotPasword.vue?vue&type=script&lang=js&"
export * from "./DialogForgotPasword.vue?vue&type=script&lang=js&"
import style0 from "./DialogForgotPasword.vue?vue&type=style&index=0&id=529e49bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e49bc",
  null
  
)

export default component.exports